import { Routes } from '@angular/router';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { AuctionPageComponent } from './pages/auction-page/auction-page.component';
import { SummaryAuctionPageComponent } from './pages/summary-auction-page/summary-auction-page.component';
import { preventReturnToAuctionGuard } from './guards/prevent-return-to-auction.guard';
import { UserCodesPageComponent } from './pages/user-codes-page/user-codes-page.component';
import { ImportCodePageComponent } from './pages/import-code-page/import-code-page.component';
import { UseCodePageComponent } from './pages/use-code-page/use-code-page.component';
import { CodesReelComponent } from './pages/codes-reel/codes-reel.component';
import { AuctionsListPageComponent } from './pages/auctions-list-page/auctions-list-page.component';

export const appRoutes: Routes = [
  { path: '', component: HomePageComponent },
  { path: 'codes', component: UserCodesPageComponent },
  { path: 'code/import/:id', component: ImportCodePageComponent },
  { path: 'code/use/:id', component: UseCodePageComponent },
 { path: 'auction/:id', component: AuctionPageComponent },

  { path: 'auctions/:id/summary', component: SummaryAuctionPageComponent },
  { path: 'auction-list', component: AuctionsListPageComponent },
  { path: 'codes-reel', component: CodesReelComponent },
  { path: 'auction-list/:id', component: AuctionsListPageComponent },
  { path: 'codes-reel/:id', component: CodesReelComponent },

  { path: '**', redirectTo: '' },
];
